export default __webpack_public_path__ + "static/media/codigo_etica_ge.f944de87.pdf";